import React, { useState } from "react";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomNumberInput from "../../../../components/CustomNumberInput";
import { ConstantService } from "../../../../services/ConstantService";
import CustomTextInput from "../../../../components/CustomTextInput";
import { Helpers } from "../../../../helpers/Helpers";
import Box from "../../../../components/Box";
import { GetAmbarByIdResponseAmbarProduct } from "../../../../models/response/ambar/GetAmbarByIdResponse";
import { storeAreYouSureModalCallback } from "../../../../redux/reducers/authSlice";
import { useDispatch } from "react-redux";

interface Props {
    productInformationRef: any
    ambarProducts: GetAmbarByIdResponseAmbarProduct[]
    setAmbarProducts: React.Dispatch<React.SetStateAction<GetAmbarByIdResponseAmbarProduct[]>>
    /**
     * Detay listesi her degistiginde siparisi kaydeder ve ekranda kalir.
     * Yeni liste parametre olarak verilir: setAmbarProducts hemen etki etmedigi
     * icin kaydin eski listeyle gitmemesi gerekiyor.
     */
    onDetailsSaved?: (_products: GetAmbarByIdResponseAmbarProduct[]) => void
}

const OrderDetails = ({ productInformationRef, ambarProducts, setAmbarProducts, onDetailsSaved }: Props) => {
    const dispatch = useDispatch();
    const [ambarProductId, setAmbarProductId] = useState<string | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);
    const [quantity, setQuantity] = useState<string | undefined>(undefined);
    const [selectedPotType, setSelectedPotType] = useState<CustomSingleSelectModel | undefined>(undefined);
    // Urun artik serbest metin degil, firmanin kendi tanimladigi sabitlerden secilir.
    const [selectedProduct, setSelectedProduct] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [weight, setWeight] = useState<string | undefined>(undefined);
    const [desi, setDesi] = useState<string | undefined>(undefined);
    const [detailVolumetricWeight, setDetailVolumetricWeight] = useState<string | undefined>(undefined);
    const [width, setWidth] = useState<string | undefined>(undefined);
    const [length, setLength] = useState<string | undefined>(undefined);
    const [height, setHeight] = useState<string | undefined>(undefined);
    const [description, setDescription] = useState<string | undefined>(undefined);

    const saveItem = () => {
        var yeniListe: GetAmbarByIdResponseAmbarProduct[] = [];

        if (Helpers.isEmpty(ambarProductId)) {
            var o: GetAmbarByIdResponseAmbarProduct = {
                ambarProductId: Helpers.generateUUID(true),
                isSelected: false,
                detailVolumetricWeight: detailVolumetricWeight,
                potTypeId: selectedPotType?.value,
                potTypeName: selectedPotType?.label,
                product: selectedProduct?.label,
                productId: selectedProduct?.value,
                productName: selectedProduct?.label,
                quantity: quantity,
                weight: weight,
                desi: desi,
                height: height,
                length: length,
                width: width,
                description: description,
            }

            yeniListe = [...ambarProducts, o];

            setAmbarProducts(yeniListe)
        }
        else {
            yeniListe = ambarProducts.map(function (x) {
                if (x.ambarProductId == ambarProductId) {
                    x.isSelected = false;
                    x.detailVolumetricWeight = detailVolumetricWeight;
                    x.potTypeId = selectedPotType?.value;
                    x.potTypeName = selectedPotType?.label;
                    x.product = selectedProduct?.label;
                    x.productId = selectedProduct?.value;
                    x.productName = selectedProduct?.label;
                    x.quantity = quantity;
                    x.weight = weight;
                    x.desi = desi;
                    x.height = height;
                    x.length = length;
                    x.width = width;
                    x.description = description;
                }

                return x;
            });

            setAmbarProducts(yeniListe)
        }

        setAmbarProductId('');
        setQuantity('');
        setSelectedPotType(undefined);
        setSelectedProduct(undefined);
        setWeight('');
        setDesi('');
        setDetailVolumetricWeight('');
        setHeight('');
        setLength('');
        setWidth('');
        setDescription('');

        setIsOpen(false);
        scrollTo();

        // Siparis burada kaydedilir: ilk detayla birlikte siparis olusur, ekranda
        // kalinir ve "Fiyat Bul" acilir. Sonraki detaylar ayni siparise eklenir.
        onDetailsSaved?.(yeniListe);
    }

    const setItemSelected = (_id: string) => {
        setAmbarProducts(ambarProducts.map(function (x) {
            if (x.ambarProductId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setAmbarProductId('');
        setQuantity('');
        setSelectedPotType(undefined);
        setSelectedProduct(undefined);
        setWeight('');
        setDesi('');
        setDetailVolumetricWeight('');
        setHeight('');
        setLength('');
        setWidth('');
        setDescription('');

        setIsOpen(false);
        scrollTo();
    }

    const setUpdateItem = () => {
        var o = ambarProducts.filter(x => x.isSelected)[0];

        setAmbarProductId(o.ambarProductId);

        setQuantity(o.quantity);
        setSelectedPotType(o.potTypeId && o.potTypeName ? { label: o.potTypeName, value: o.potTypeId } : undefined);
        setSelectedProduct(o.productId ? { label: o.productName ?? o.product ?? '', value: o.productId } : undefined);
        setWeight(o.weight);
        setDesi(o.desi);
        setDetailVolumetricWeight(o.detailVolumetricWeight);
        setHeight(o.height);
        setLength(o.length);
        setWidth(o.width);
        setDescription(o.description);

        setIsOpen(true);
        scrollTo();
    }

    const deleteItems = async () => {
        var kalanlar = ambarProducts.filter(x => !x.isSelected);

        setAmbarProducts(kalanlar);

        onDetailsSaved?.(kalanlar);
    }

    // Dip toplam (07.10.2026): Ağırlık, Desi, Detay Hacimsel Ağırlık.
    const toplam = (alan: 'weight' | 'desi' | 'detailVolumetricWeight') =>
        Helpers.correctPrice(Helpers.sumOfNumbers(ambarProducts.map(x => Helpers.toNumber(x[alan]?.toString()))), 2);

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = productInformationRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    const selectAll = () => {
        var isAllSelected = ambarProducts.length == ambarProducts.filter(x => x.isSelected).length;

        setAmbarProducts(ambarProducts.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const setCustomDesi = (val: string) => {
        setDesi(val);

        if (Helpers.isEmpty(val))
            setDetailVolumetricWeight(weight ?? '');
        if (Helpers.isEmpty(weight))
            setDetailVolumetricWeight(val ?? '');
        else {
            var v1 = Helpers.toNumber(val);
            var v2 = Helpers.toNumber(weight);

            setDetailVolumetricWeight(v1 > v2 ? val : weight);
        }
    }

    return (
        <div className='containerPart' ref={productInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Sipariş Detayları</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className="row">
                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Kap Cinsi"
                                            isLabelRequired
                                            selectedValue={selectedPotType}
                                            onChange={setSelectedPotType}
                                            // insertable={{
                                            //     onSubmit: { code: 'POT_TYPE' }
                                            // }}
                                            onMenuOpen={() => ConstantService.getConstantList('POT_TYPE')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Adet" isLabelRequired value={quantity} setValue={setQuantity} />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomSingleSelect
                                            labelText="Ürün"
                                            isLabelRequired
                                            selectedValue={selectedProduct}
                                            onChange={setSelectedProduct}
                                            insertable={{
                                                onSubmit: { code: 'AMBAR_PRODUCT' },
                                                tooltipText: 'Listede yoksa buradan ekleyin'
                                            }}
                                            onMenuOpen={() => ConstantService.getConstantList('AMBAR_PRODUCT')}
                                            labelName='value'
                                            valueName='constantId'
                                        />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="En (cm)" value={width} setValue={(val: string) => {
                                            setWidth(val);
                                            setCustomDesi(((Helpers.toNumber(val ?? "0") * Helpers.toNumber(length ?? "0") * Helpers.toNumber(height ?? "0")) / 3000).toFixed(2))
                                        }} />
                                    </div>
                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Boy (cm)" value={length} setValue={(val: string) => {
                                            setLength(val);
                                            setCustomDesi(((Helpers.toNumber(width ?? "0") * Helpers.toNumber(val ?? "0") * Helpers.toNumber(height ?? "0")) / 3000).toFixed(2))
                                        }} />
                                    </div>
                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Yükseklik (cm)" value={height} setValue={(val: string) => {
                                            setHeight(val);
                                            setCustomDesi(((Helpers.toNumber(width ?? "0") * Helpers.toNumber(length ?? "0") * Helpers.toNumber(val ?? "0")) / 3000).toFixed(2))
                                        }} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Ağırlık" isLabelRequired value={weight}
                                            setValue={(val: string) => {
                                                setWeight(val);

                                                if (Helpers.isEmpty(val))
                                                    setDetailVolumetricWeight(desi ?? '');
                                                if (Helpers.isEmpty(desi))
                                                    setDetailVolumetricWeight(val ?? '');
                                                else {
                                                    var v1 = Helpers.toNumber(val);
                                                    var v2 = Helpers.toNumber(desi);

                                                    setDetailVolumetricWeight(v1 > v2 ? val : desi);
                                                }
                                            }}
                                        />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomNumberInput isDisabled labelText="Desi" isLabelRequired value={desi} setValue={setCustomDesi} />
                                    </div>

                                    <div className="col-md-4">
                                        <CustomNumberInput labelText="Detay Hacimsel Ağırlık" isLabelRequired value={detailVolumetricWeight} setValue={setDetailVolumetricWeight} isDisabled />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-4">
                                        <CustomTextInput labelText="Açıklama" isLabelRequired value={description} setValue={setDescription} />
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} opacity={"1"} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={ambarProducts.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={ambarProducts.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>

                        <Box onClick={ambarProducts.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={ambarProducts.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={ambarProducts.filter(x => x.isSelected).length > 0 && ambarProducts.filter(x => x.isSelected).length == ambarProducts.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Kap Cinsi</th>
                                            <th>Adet</th>
                                            <th>Ürün</th>
                                            <th>En (cm)</th>
                                            <th>Boy (cm)</th>
                                            <th>Yükseklik (cm)</th>
                                            <th>Ağırlık</th>
                                            <th>Desi</th>
                                            <th>Detay Hacimsel Ağırlık</th>
                                            <th>Açıklama</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            ambarProducts.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            ambarProducts.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                <input onChange={() => setItemSelected(item.ambarProductId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.potTypeName}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.product}</td>
                                                    <td>{item.width}</td>
                                                    <td>{item.length}</td>
                                                    <td>{item.height}</td>
                                                    <td>{item.weight}</td>
                                                    <td>{item.desi}</td>
                                                    <td>{item.detailVolumetricWeight}</td>
                                                    <td>{item.description}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                    {
                                        ambarProducts.length > 0 && (
                                            <tfoot>
                                                <tr className="ebbe-dip-toplam">
                                                    <td style={{ width: 1 }}></td>
                                                    <td>Toplam</td>
                                                    <td colSpan={5}></td>
                                                    <td>{toplam('weight')}</td>
                                                    <td>{toplam('desi')}</td>
                                                    <td>{toplam('detailVolumetricWeight')}</td>
                                                    <td></td>
                                                </tr>
                                            </tfoot>
                                        )
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default OrderDetails;